import axios from 'axios';
import { getEndpoint, getRequestHeaders  } from './config'

export default function (destination: any) {
    return new Promise<any>((resolve, reject) => {
        axios
            .post(
                getEndpoint('destinations', null),
                destination,
                getRequestHeaders(true)
            )
            .then(function (response : any) {
                resolve(response.data);
            })
            .catch(function (rs : any) {
                reject(rs);
            });
    });
}